import {
  ADD_RECOMMENDATION,
  EDIT_RECOMMENDATION,
  REMOVE_RECOMMENDATIONS,
  FETCH_HEFTY_CROPS,
  FETCH_RECOMMENDATIONS,
  FETCH_RECOMMENDATION_BY_ID,
} from './constants'

export function addRecommendation (payload) {
  return {
    type: ADD_RECOMMENDATION,
    payload,
  }
}

export function editRecommendation (payload) {
  return {
    type: EDIT_RECOMMENDATION,
    payload,
  }
}

export function removeRecommendation () {
  return {
    type: REMOVE_RECOMMENDATIONS,
  }
}


export function fetchHeftyCrops () {
  return {
    type: FETCH_HEFTY_CROPS,
  }
}

export function fetchRecommendations () {
  return {
    type: FETCH_RECOMMENDATIONS,
  }
}

export function fetchRecommendationById (payload) {
  return {
    type: FETCH_RECOMMENDATION_BY_ID,
    payload,
  }
}
